"use strict";
const COPACK_QVANTI_ID_IN_FRESHX = 363;
const FLAIVY_ORGANIZATION_IDS = [
    '1bf1cd61-a810-479f-b538-cfc6a49b35ad', // dev
    'fb7332dd-4743-433f-b037-641730e0c1b4', // prod
];
const PRIVAB_OWNING_SUPPLIER_ORGANIZATION_ID = 'd2e43f16-561e-4cf1-a959-fd3fe30f0d77';
const getOfcFromZipCode = (organization, zipCode) => {
    // Remove spaces from zip code
    let cleanedZipCode = zipCode.replace(/\s/g, '');
    // Add 0 to zip code if it is less than 5 characters
    if (cleanedZipCode.length < 5) {
        cleanedZipCode = cleanedZipCode.padEnd(5, '0');
    }
    const zipCodeToOfcMaps = organization.zipCodeToOfcMaps;
    const matchingMap = zipCodeToOfcMaps.find(map => parseInt(cleanedZipCode, 10) >= parseInt(map.zipCodeStart, 10) &&
        parseInt(cleanedZipCode, 10) <= parseInt(map.zipCodeEnd, 10));
    return matchingMap
        ? matchingMap.orderFullfillmentCenter
        : organization.defaultOrderFullfillmentCenter;
};
module.exports = {
    getOfcFromZipCode,
    COPACK_QVANTI_ID_IN_FRESHX,
    FLAIVY_ORGANIZATION_IDS,
    PRIVAB_OWNING_SUPPLIER_ORGANIZATION_ID,
};
